/**
 * Himmelsrichtungen.
 *
 * Ein Kurs in Grad ist für ein Gerät die richtige Angabe und für einen Fahrer
 * die falsche: „315°" muss man umrechnen, „NW" liest man im Vorbeischauen. Am
 * Steuer zählt allein das Zweite.
 *
 * Acht Sektoren zu je 45°, keine sechzehn. „NNW" und „NW" sind auf einem Blick
 * von einer Sekunde nicht zu unterscheiden — die zusätzliche Feinheit wäre
 * bezahlt mit einer Angabe, die man zweimal lesen muss.
 */
/** Kürzel, bei Norden beginnend und im Uhrzeigersinn. */
export const COMPASS_POINTS = Object.freeze([
    'N',
    'NO',
    'O',
    'SO',
    'S',
    'SW',
    'W',
    'NW',
]);
/** Ausgeschrieben — für Vorlesen und für alles, wo Platz ist. */
export const COMPASS_NAMES = Object.freeze({
    N: 'Norden',
    NO: 'Nordosten',
    O: 'Osten',
    SO: 'Südosten',
    S: 'Süden',
    SW: 'Südwesten',
    W: 'Westen',
    NW: 'Nordwesten',
});
/**
 * Das Kürzel zu einem Kurs.
 *
 * Der Sektor ist um seine Richtung **zentriert**: Norden reicht von 337,5° bis
 * 22,5°, nicht von 0° bis 45°. Sonst hieße ein Kurs von 20° bereits
 * „Nordosten", obwohl das Fahrzeug fast genau nach Norden fährt.
 *
 * Werte außerhalb von 0–360° werden zurechtgerückt; ein Gerät, das 720° oder
 * −45° meldet, meint dasselbe wie 0° beziehungsweise 315°.
 */
export function compassPoint(headingDeg) {
    const kurs = ((headingDeg % 360) + 360) % 360;
    const sektor = Math.round(kurs / 45) % 8;
    // Der Index liegt durch die Modulo-Rechnung immer zwischen 0 und 7.
    return COMPASS_POINTS[sektor] ?? 'N';
}
/**
 * Der kleinere der beiden Winkel zwischen zwei Richtungen, in Grad — also
 * immer zwischen 0 und 180.
 *
 * Zwei Stellen brauchen dieselbe Rechnung und dürfen dabei nicht auseinander
 * laufen: die Zuordnung zur Führungsspur, die Vorbeifahrten in der
 * Gegenrichtung verwirft, und der Wendehinweis, der genau diese Gegenrichtung
 * sucht.
 */
export function winkelabstand(a, b) {
    const roh = Math.abs(((a - b) % 360) + 360) % 360;
    return roh > 180 ? 360 - roh : roh;
}
//# sourceMappingURL=compass.js.map